import { AxiosInstance } from "axios";
import { IResponseBody } from "../../Schemas/EndPoint";
import { PbxServerSchema } from "../../Schemas/PbxServer";

export interface PbxServerResponseBody extends IResponseBody {
  data: {
    pbx_server: PbxServerSchema;
  };
}

interface PbxServerCreateRequestBody {
  workspace_id: null | string;
  pbx_driver: string;
  server_url: string;
  username: string;
  password: string;
  status:string;
  caption: string;
  description: string;
  max_pending_calls:number;
}

export class PbxServerUpdateRequest {
  private protectedAxiosInstance: AxiosInstance;

  constructor(protectedAxiosInstance: AxiosInstance) {
    this.protectedAxiosInstance = protectedAxiosInstance;
  }

  private getPath(id: number) {
    return `/admin/pbx-servers/${id}/update`;
  }

  async send(
    serverId: number,
    contactCreateBody: PbxServerCreateRequestBody
  ): Promise<PbxServerResponseBody> {
    try {
      const { data } = await this.protectedAxiosInstance.post(
        this.getPath(serverId),
        contactCreateBody
      );
      return data;
    } catch (err) {
      // TODO : handle error
      throw err;
    }
  }
}
